import dayjs from 'dayjs';

export default function helperDate(date = new Date(), format = 'DD/MM/YYYY') {
  return dayjs(date).format(format);
}
